import "./people.css"
import React, { useEffect } from "react";
import { Paper } from "@material-ui/core";

export default function People(props) {
    useEffect(() => {
        document.title = "Smishtank: People"
    }, []);

    return (
        <div className="people">
            <div className="peopleContainer">
               <h2 className="Titleblock">
                People
               </h2>
               <Paper>
                    <div className="pictureCardContainer">
                        <div className="pictureCard">
                        <div className="jobTitle">&nbsp;</div>
                            <div className="innerPictureCard">
                                <img alt="profile-pic" className="pfpimage" src={require('../../lutfor.jpg')} />
                            </div>
                            <div className="cardText">
                                <div className="nameTitle">
                                    Muhammad Lutfor Rahman, Ph.D
                                </div>
                                <div className="universityText">
                                    <a href="mailto:mlrahman@smishtank.com" className="profLink">
                                        CEO - Smishtank.com
                                        <br />
                                        mlrahman@smishtank.com
                                    </a>
                                </div>  
                            </div>
                        </div>
                        <div className="pictureCard">
                            <div className="jobTitle">&nbsp;</div>
                            <div className="innerPictureCard">
                                <img alt="profile-pic" className="pfpimage" src={require('../../DanPFP.JPG')} />
                            </div>
                            <div className="cardText">
                                <div className="nameTitle">
                                    Daniel Timko
                                </div>
                                <div className="universityText">
                                    <a href="mailto:daniel@smishtank.com" className="profLink">
                                        CTO - Smishtank.com
                                        <br />
                                        daniel@smishtank.com
                                    </a>
                                </div>  
                            </div>
                        </div>
                    </div>
               </Paper>
               
            </div>
        </div>
    )
}